import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { css, styled } from 'styled-components';
import { Box } from "../../box/src";
import { Card } from "../../card/src";
import { CATEGORIES, FontAwesomeIcon } from "../../font-awesome-icon/src";
export const INFOBOX_STATUS = Object.freeze({
    ALERT: 'ALERT',
    ERROR: 'ERROR',
    INFO: 'INFO',
    SUCCESS: 'SUCCESS',
});
const INFOBOX_STATUS_PROPS = {
    ALERT: {
        boxShadow: 'mandarine',
    },
    ERROR: {
        boxShadow: 'fire',
    },
    INFO: {
        boxShadow: 'primary',
    },
    SUCCESS: {
        boxShadow: 'grass',
    },
};
export const Infobox = ({ children, iconName = 'circle-info', status = INFOBOX_STATUS.INFO, title, }) => {
    var _a;
    return (_jsxs(StyledCard, { "$status": status, display: "block", px: 5, py: 4, children: [_jsxs(Box, { alignItems: "center", children: [_jsx(Box, { color: (_a = INFOBOX_STATUS_PROPS[status]) === null || _a === void 0 ? void 0 : _a.boxShadow, mr: 3, children: _jsx(FontAwesomeIcon, { height: "24px", iconName: iconName, iconType: CATEGORIES.SOLID }) }), _jsx(Box, { font: children ? 'h4-semibold' : 'body-regular-asphalt', children: title })] }), children && (_jsx(Box, { display: "block", mt: 3, width: "100%", children: children }))] }));
};
const StyledCard = styled(Card) `
  ${({ $status, theme }) => {
    var _a, _b;
    return css `
    box-shadow: ${(_a = theme.colors) === null || _a === void 0 ? void 0 : _a[(_b = INFOBOX_STATUS_PROPS[$status]) === null || _b === void 0 ? void 0 : _b.boxShadow]} 0 0 0 2px;
  `;
}}
`;
//# sourceMappingURL=Infobox.js.map